import { useNavigate } from "react-router";
import "./promotions.scss";
import { restaurantsListPath } from "../main";
import { isToday, parseISO } from "date-fns";
import { useUser } from "../../context/user-context";

export const Promotions = () => {
    const navigate = useNavigate();
    const { user } = useUser();

    const promotionData = [
        {
            name: "Cheeseburger & Fries",
            description: "1 Cheeseburger + 1 Fries",
            price: "$15.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:45:53.592-9.webp",
        },
        {
            name: "2 Cheeseburgers for $20.99",
            description: "2 Cheeseburgers for $20.99",
            price: "$20.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:46:13.519-5.webp",
        },
        {
            name: "Double Cheeseburger, Cheeseburger & Fries",
            description: "1 Double Cheeseburger + 1 Cheeseburger + 1 Fries",
            price: "$29.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:46:29.438-4.webp",
        },
        {
            name: "Spicy Chicken & Fries",
            description: "1 Spicy Chicken Burger + 1 Fries",
            price: "$19.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:46:50.965-1.webp",
        },
        {
            name: "Spicy Chicken Burger, Cheeseburger & Fries",
            description: "1 Spicy Chicken Burger + 1 Cheeseburger + 1 Fries",
            price: "$28.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:47:10.541-7.webp",
        },
        {
            name: "Buffalo Chicken & Fries",
            description: "1 Buffalo Fried Chicken + 1 Fries",
            price: "$16.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:47:29.20-2.webp",
        },
        {
            name: "2 Fries for $9.99",
            description: "2 Fries for $9.99",
            price: "$9.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:48:04.561-3.webp",
        },
        {
            name: "2 Epic Fries for $12.99",
            description: "2 Epic Fries for $12.99",
            price: "$12.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:48:15.826-6.webp",
        },
        {
            name: "2 Oreo Shakes for $13.99",
            description: "2 Oreo Shakes shakes for $13.99",
            price: "$13.99",
            image: "https://d1hfsnuz4i23pd.cloudfront.net/protected/ap-southeast-2:4a785247-e07c-c51d-9d7a-eaed83da2f65/2025-11-19_06:48:38.964-8.webp",
        },
    ];

    return (
        <div>
            {user && isToday(parseISO(user.createdAt)) && (
                <div className="promotions red" onClick={() => navigate(`${restaurantsListPath}`)}>
                    <div>
                        <div className="h3 promotion-name-red">FREE FRIES</div>
                        <div className="mt-1">FREE FRIES AUTOMATICALLY ADDED TO YOUR FIRST ORDER</div>
                        <div className="mt-1 text-bold">NEW CUSTOMER OFFER</div>
                    </div>
                </div>
            )}
            {promotionData.map((p, index) => (
                <div className="promotions" onClick={() => navigate(`${restaurantsListPath}`)}>
                    <div>
                        <div className="h3 promotion-name">{p.name}</div>
                        <div className="mt-1">{p.description}</div>
                        <div className="mt-1 text-bold">{p.price}</div>
                        <div className="mt-1 promotion-limited-time-only">Limited Time Only!</div>
                    </div>
                    <div>
                        <img className="mt-1 promotion-image" src={p?.image} />
                    </div>
                </div>
            ))}
        </div>
    );
};
